import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keyBy } from 'lodash';
import { ProjectAccountingAPI } from 'api/settings-financials';
export const FinancialNotificationsConfigQueryKey = ()=>[
        'financial-notifications-key'
    ];
export const useFinancialNotificationsConfigQuery = (options = {})=>{
    return useQuery(FinancialNotificationsConfigQueryKey(), ()=>ProjectAccountingAPI.getFinancialNotificationConfig(), {
        ...options
    });
};
export const useFinancialNotificationsConfigMutation = (configId, options = {})=>{
    const queryClient = useQueryClient();
    return useMutation((payload)=>ProjectAccountingAPI.updateFinancialNotificationConfig(configId, payload), {
        onSuccess: ()=>{
            queryClient.refetchQueries(FinancialNotificationsConfigQueryKey());
        },
        ...options
    });
};
export const RevenueRecognitionConfigQueryKey = ()=>[
        'revenue-recoginition-query-key'
    ];
export const RevenueRecognitionProjectCountQueryKey = ()=>[
        'revenue-recoginition-project-count-query-key'
    ];
const getTransformedRevenueRecognitionConfig = (config)=>keyBy(config, 'financialContractType');
export const useRevenueRecognitionConfigQuery = (options = {})=>{
    return useQuery(RevenueRecognitionConfigQueryKey(), async ()=>{
        const config = await ProjectAccountingAPI.getRevenueRecognitionConfig();
        return getTransformedRevenueRecognitionConfig(config);
    }, {
        ...options
    });
};
export const useRevenueRecognitionProjectCountQuery = (options = {})=>{
    return useQuery(RevenueRecognitionProjectCountQueryKey(), async ()=>{
        const config = await ProjectAccountingAPI.getCustomRevenueRecognitionProjectCount();
        return config;
    }, {
        ...options
    });
};
export const useRevenueRecognitionConfigMutation = (options = {})=>{
    return useMutation((payload)=>ProjectAccountingAPI.updateRevenueRecognitionConfig(payload), {
        ...options
    });
};
const CUSTOM_REVENUE_RECOGNITION_CONFIG_QUERY_KEY = [
    'custom-revenue-recognition-query'
];
export const customRevenueRecognitionQueryKey = (includeProjects = false)=>[
        CUSTOM_REVENUE_RECOGNITION_CONFIG_QUERY_KEY[0],
        includeProjects.valueOf().toString()
    ];
export const useCustomRevenueRecognitionQuery = (includeProjects = false, options = {})=>{
    return useQuery(customRevenueRecognitionQueryKey(includeProjects), ()=>ProjectAccountingAPI.getCustomRevenueRecognitionConfig(includeProjects), options);
};
export const useCreateCustomRevenueRecognitionMutation = (options = {})=>{
    const queryClient = useQueryClient();
    return useMutation((payload)=>ProjectAccountingAPI.createCustomRevenueRecognitionConfig(payload), {
        ...options,
        onSuccess: async ()=>{
            await queryClient.refetchQueries(CUSTOM_REVENUE_RECOGNITION_CONFIG_QUERY_KEY);
        }
    });
};
export const useUpdateCustomRevenueRecognitionMutation = (customRevenueRecognitionId, options = {})=>{
    const queryClient = useQueryClient();
    return useMutation((payload)=>ProjectAccountingAPI.updateCustomRevenueRecognitionConfig(customRevenueRecognitionId, payload), {
        ...options,
        onSuccess: async ()=>{
            await queryClient.refetchQueries(CUSTOM_REVENUE_RECOGNITION_CONFIG_QUERY_KEY);
        }
    });
};
export const useDeleteCustomRevenueRecognitionMutation = (customRevenueRecognitionConfigId, options = {})=>{
    const queryClient = useQueryClient();
    return useMutation(()=>ProjectAccountingAPI.deleteCustomRevenueRecognitionConfig(customRevenueRecognitionConfigId), {
        ...options,
        onSuccess: async ()=>{
            await queryClient.refetchQueries(CUSTOM_REVENUE_RECOGNITION_CONFIG_QUERY_KEY);
        }
    });
};
export const FinancialsConfigurationQueryKey = ()=>[
        'financials-configuration-query-key'
    ];
export const useFinancialsConfigurationQuery = (options = {})=>{
    return useQuery(FinancialsConfigurationQueryKey(), ()=>ProjectAccountingAPI.getFinancialsConfiguration(), {
        ...options
    });
};
export const useFinancialsConfigurationMutation = (options = {})=>{
    const queryClient = useQueryClient();
    return useMutation((payload)=>ProjectAccountingAPI.updateFinancialsConfiguration(payload), {
        onSuccess: ()=>{
            queryClient.refetchQueries(FinancialsConfigurationQueryKey());
        },
        ...options
    });
};
